export default __webpack_public_path__ + "d798d9f.png";